<template>
  <UIInputDynamicList
    v-model="modelValue"
    :data
  >
    <template #item="{ item, itemClasses, dataRefid, onClick }">
      <div
        class="ui-dropdown-list-item asset-tag-name-input__item"
        :class="itemClasses"
        :data-refid="dataRefid"
        @click="onClick"
      >
        <span>{{ item.label }}</span>
        <Info
          v-if="item.disabled"
          v-tooltip.right="USED_NAME_TOOLTIP"
          class="asset-tag-name-input__info"
          aria-hidden="true"
        />
      </div>
    </template>
  </UIInputDynamicList>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import { orderBy } from 'lodash'
import { Info } from '@lucide/vue'

import { UIInputDynamicList } from '@ui/fields'

type Props = {
  names: string[]
  usedNames: Set<string>
}

const USED_NAME_TOOLTIP =
  'This asset already has a tag with this name. Remove it first to add another value.'

const props = defineProps<Props>()

const modelValue = defineModel<string | undefined>({ required: true })

// A disabled dropdown item is still clickable; reject the click.
provide('selectionChecker', (_: unknown, disabled?: boolean) =>
  disabled ? Promise.reject() : Promise.resolve(),
)

const data = computed(() =>
  orderBy([...new Set(props.names)]).map(value => ({
    value,
    label: value,
    disabled: props.usedNames.has(value),
  })),
)
</script>

<style>
.asset-tag-name-input__item {
  @apply flex items-center justify-between gap-2;
}

.asset-tag-name-input__item.ui-dropdown-list-item--disabled {
  @apply cursor-not-allowed;

  &:hover {
    @apply bg-transparent;
    @apply text-[var(--text-color)];
  }
}

.asset-tag-name-input__info {
  @apply size-4 shrink-0;
}
</style>
